import cx from "classnames";
import { faCalendarClock, faCalendarHeart, faTruckFast } from "@fortawesome/pro-regular-svg-icons";

import { toDate } from "common/utils/dates";
import { UISubscriptionStatus, UserSubscriptionAction } from "common/types";
import Icon from "common/components/Icon";

import { ModalStatus } from "client/common/types";
import PillButton from "client/common/components/buttons/PillButton";
import { urls } from "client/routes";

import { ClientSubscription, ListSubscription, SubscriptionForm } from "../types";
import SubscriptionStatus from "./SubscriptionStatus";
import { getLabelForSubscriptionStatus } from "../utils";

import styles from "../styles/SubscriptionActions.module.less";

type SubscriptionActionsProps = {
  subscription: ClientSubscription | ListSubscription;
  classNames?: {
    actions?: string;
    action?: string;
  };
};

const SubscriptionActions = (props: SubscriptionActionsProps) => {
  const { subscription, classNames } = props;

  const hasModifyAction = subscription.potential_user_actions.find(
    ([action]) => action === UserSubscriptionAction.Modify,
  );

  const actions = [
    {
      icon: faCalendarClock,
      value:
        subscription.visible_status === UISubscriptionStatus.Active ? (
          toDate(subscription.next_order_date)
        ) : (
          <span className={styles.status}>
            {getLabelForSubscriptionStatus(subscription.visible_status)}{" "}
            <SubscriptionStatus.Icon subscription={subscription} />
          </span>
        ),
      label: "Next order",
      action: hasModifyAction && {
        dest: urls.subscriptions.detail({
          params: { id: subscription.id },
          search: {
            form: SubscriptionForm.UpdateNextOrder,
            visible: ModalStatus.Open,
          },
        }),
        label: "Change",
      },
    },
    {
      icon: faCalendarHeart,
      value: subscription.active_frequency.display,
      label: "Frequency",
      action: hasModifyAction && {
        dest: urls.subscriptions.detail({
          params: { id: subscription.id },
          search: {
            form: SubscriptionForm.UpdateFrequency,
            visible: ModalStatus.Open,
          },
        }),
        label: "Change",
      },
    },

    {
      icon: faTruckFast,
      value: subscription.last_order ? toDate(subscription.last_order.order_placed_time) : "-",
      label: "Last order",
      action: subscription.last_order && {
        dest: urls.orders.detail({ params: { id: subscription.last_order.id } }),
        label: "View",
      },
    },
  ];

  return (
    <div className={cx(styles.actions, classNames?.actions)}>
      {actions.map((action) => (
        <div className={cx(styles.action, classNames?.action)} key={action.label}>
          <div className={styles.main}>
            <div className={styles.icon}>
              <Icon fixedWidth={true} icon={action.icon} />
            </div>
            <div className={styles.text}>
              <div className={styles.value}>{action.value}</div>
              <div className={styles.label}>{action.label}</div>
            </div>
          </div>
          {action.action && (
            <PillButton
              className={styles.button}
              variant="secondary"
              size="s"
              dest={action.action.dest}
            >
              {action.action.label}
            </PillButton>
          )}
        </div>
      ))}
    </div>
  );
};

export default SubscriptionActions;
